import { createContext, useState } from "react";

export const StateDashBoardProviderContext = createContext<IStateDashBoardProviderContext | undefined>(undefined);


export interface IStateDashBoardProviderContext {
    type: "this_year" | "last_year",
    setType: any,

    typeVisit: "this_year" | "last_year",
    setTypeVisit: any
}

export const StateDashBoardProviderProvider = ({ children }: any) => {
    const [type, setType] = useState<"this_year" | "last_year">("this_year");
    const [typeVisit, setTypeVisit] = useState<"this_year" | "last_year">("this_year");


    return (
        <StateDashBoardProviderContext.Provider value={{ type, setType, typeVisit, setTypeVisit }}>
            {children}
        </StateDashBoardProviderContext.Provider>
    );
}